module.exports = __webpack_public_path__ + "static/media/logout-icon.dd262a4b.svg";